import type { TldPricing } from "@kilat/contracts/tld-pricing";
import { useMutation } from "@tanstack/react-query";
import { setTldOffered } from "../api";
import { staffKeys } from "../queries";

// The answer is the TLD as the list shows it: it replaces that row in the cached list.
export const useSetTldOffered = (tldId: string) =>
  useMutation({
    mutationFn: (offered: boolean) => setTldOffered(tldId, { offered }),
    onSuccess: ({ data }, _offered, _result, { client }) => {
      client.setQueryData(staffKeys.tldPricing(), (list: TldPricing[] | undefined) =>
        list?.map((tld) => (tld.id === data.id ? data : tld)),
      );
    },
  });
